import React from "react";
import styled from "styled-components";
import {
  FaBars,
  FaUndo,
  FaFlask,
  FaExpandArrowsAlt,
  FaBalanceScale,
  FaLaptopCode,
  FaAward,
  FaBullseye,
  FaEye,
  FaLightbulb,
  FaPhoneAlt,
  FaClipboardList,
  FaHandshake,
  FaUsers,
  FaUniversity,
  FaGlobe,
  FaShieldAlt,
  FaLock,
  FaHeadset,
  FaBullhorn,
  FaEnvelope,
  FaUserShield,
  FaClock,
  FaChartLine,
  FaFileAlt,
  FaHandHoldingUsd,
  FaHandHoldingHeart,
} from "react-icons/fa";

// 1. CONSTANTES DE COLOR
const guinda = "#611232";
const guinda2 = "#8b1d47";
const guindaLight = "#8b1d47";
const verde = "#137333";
const grisFondo = "#f8f9fa";
const grisTexto = "#4a4a4a";

// 2. DATOS
const historia = [
  {
    anio: "2020",
    titulo: "Inicio del proyecto piloto",
    texto: "Se lanza la primera fase en coordinación con PROFECO.",
    icono: <FaFlask />,
  },
  {
    anio: "2021",
    titulo: "Expansión nacional",
    texto: "Se integran CONDUSEF y CNBV.",
    icono: <FaExpandArrowsAlt />,
  },
  {
    anio: "2022",
    titulo: "Consolidación legal",
    texto: "Se formaliza la estructura jurídica del programa.",
    icono: <FaBalanceScale />,
  },
  {
    anio: "2024",
    titulo: "Integración tecnológica",
    texto: "Se implementan programas de rastreo efectivos.",
    icono: <FaLaptopCode />,
  },
  {
    anio: "2025",
    titulo: "Reconocimiento institucional",
    texto: "La Campaña se consolida como modelo nacional.",
    icono: <FaAward />,
    verde: true,
  },
];

const misionVision = [
  {
    titulo: "Misión",
    texto: "Brindar asesoría legal gratuita y orientación confiable.",
    icono: <FaBullseye />,
  },
  {
    titulo: "Visión",
    texto: "Ser un referente nacional en prevención de fraudes.",
    icono: <FaEye />,
  },
  {
    titulo: "Compromiso",
    texto: "Atender con empatía y transparencia.",
    icono: <FaLightbulb />,
  },
];

const proceso = [
  {
    titulo: "Recepción",
    texto: "Contacto vía WhatsApp o formulario.",
    icono: <FaPhoneAlt />,
  },
  {
    titulo: "Revisión",
    texto: "Abogados especializados analizan la viabilidad.",
    icono: <FaClipboardList />,
  },
  {
    titulo: "Reporte",
    texto: "Se emiten reportes ante instituciones oficiales.",
    icono: <FaBalanceScale />,
  },
  {
    titulo: "Gestión",
    texto: "Recuperación mediante conciliación o embargo.",
    icono: <FaHandshake />,
  },
  {
    titulo: "Entrega",
    texto: "Validación de la devolución del recurso.",
    icono: <FaHandHoldingUsd />,
  },
];

const valores = [
  {
    titulo: "Misión",
    texto:
      "Brindar asesoría legal gratuita y orientación confiable a víctimas de fraude.",
    icono: <FaBullseye />,
  },
  {
    titulo: "Visión",
    texto:
      "Ser un referente nacional en prevención de fraudes y protección patrimonial.",
    icono: <FaEye />,
  },
  {
    titulo: "Compromiso",
    texto:
      "Atender con empatía y transparencia absoluta cada proceso de recuperación.",
    icono: <FaHandHoldingHeart />,
  },
];

const stats = [
  {
    numero: "$450M+",
    titulo: "Recuperado",
    texto: "Patrimonio restituido a víctimas",
    icono: <FaHandHoldingUsd />,
  },
  {
    numero: "150K+",
    titulo: "Asesorados",
    texto: "Atención gratuita nacional",
    icono: <FaUsers />,
  },
  {
    numero: "32",
    titulo: "Estados",
    texto: "Cobertura en todo México",
    icono: <FaGlobe />,
  },
  {
    numero: "94%",
    titulo: "Eficacia",
    texto: "Casos resueltos con éxito",
    icono: <FaAward />,
  },
];

const equipo = [
  {
    titulo: "Ciberinteligencia",
    texto: "Rastreo de activos y cuentas digitales.",
    icono: <FaLaptopCode />,
  },
  {
    titulo: "Jurídico",
    texto: "Procesos de mediación y recuperación legal.",
    icono: <FaBalanceScale />,
  },
];

// 3. STYLED COMPONENTS
const Pagina = styled.div`
  width: 100%;
  background: white;
  overflow-x: hidden;
`;

const Hero = styled.section`
  width: 100%;
  min-height: 80vh;
  background: linear-gradient(135deg, ${guinda} 0%, #2b0816 100%);
  color: white;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
`;

const TituloSuperior = styled.h1`
  margin: 0;
  background: white;
  color: ${guinda};
  text-align: center;
  font-size: clamp(1.5rem, 5vw, 3.5rem);
  font-weight: 900;
  padding: 3rem 1rem;
`;

const HeroContenido = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 4rem 2rem;
  text-align: center;
  z-index: 1;
`;

const BarraHero = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 1rem;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(10px);
  padding: 0.5rem 1.5rem;
  border-radius: 100px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  margin-bottom: 2rem;
  span {
    font-size: 0.85rem;
    font-weight: 700;
    text-transform: uppercase;
  }
`;

const MensajeHero = styled.div`
  margin-bottom: 2rem;
  font-weight: 900;
  line-height: 1.1;
`;
const Gris = styled.div`
  color: rgba(255, 255, 255, 0.6);
  font-size: clamp(1.5rem, 4vw, 3rem);
`;
const Blanco = styled.div`
  color: white;
  font-size: clamp(2rem, 6vw, 4.5rem);
  margin: 0.3rem 0;
`;
const TextoHero = styled.p`
  max-width: 700px;
  margin: 0 auto 3rem;
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.8);
`;

const BotonPrincipal = styled.button`
  background: white;
  color: ${guinda};
  border: none;
  border-radius: 100px;
  padding: 1rem 2.8rem;
  font-size: 1.1rem;
  font-weight: 800;
  cursor: pointer;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
`;

const ImagenAsesor = styled.img`
  width: 100%;
  max-width: 800px;
  margin-top: 4rem;
  border-radius: 1.5rem;
`;

const SeccionBlanca = styled.section`
  background: white;
  padding: 6rem 1.5rem;
`;
const SeccionGris = styled.section`
  background: ${grisFondo};
  padding: 6rem 1.5rem;
`;

const TituloSeccion = styled.h2`
  color: #1a1a1a;
  text-align: center;
  font-size: 2.5rem;
  font-weight: 900;
`;
const Subtitulo = styled.p`
  max-width: 600px;
  margin: 1rem auto 4rem;
  color: ${grisTexto};
  text-align: center;
`;

const IconoTitulo = styled.div`
  width: 64px;
  height: 64px;
  background: ${guindaLight};
  color: white;
  border-radius: 18px;
  margin: 0 auto 1.5rem;
  display: grid;
  place-items: center;
`;

const Timeline = styled.div`
  max-width: 800px;
  margin: 0 auto;
  position: relative;
  padding-left: 2rem;
  perspective: 1000px; // Añade profundidad para el efecto 3D

  &::before {
    content: "";
    position: absolute;
    left: 2.2rem;
    top: 0;
    bottom: 0;
    width: 2px;
    background: #eee;
  }
`;

const TimelineItem = styled.div`
  display: flex;
  gap: 2rem;
  margin-bottom: 4rem;
  transition: all 0.3s ease;
  cursor: default;

  &:hover {
    transform: translateX(10px);
  }
`;

const CirculoLinea = styled.div`
  width: 55px;
  height: 55px;
  background: white;
  color: ${guinda};
  border: 2px solid ${guinda};
  border-radius: 15px;
  display: grid;
  place-items: center;
  z-index: 2;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  transform-style: preserve-3d;

  &.verde {
    color: ${verde};
    border-color: ${verde};
  }

  ${TimelineItem}:hover & {
    transform: rotateY(180deg);
    background: ${guinda};
    color: white;
    box-shadow: 0 10px 20px rgba(97, 18, 50, 0.2);
  }

  ${TimelineItem}:hover &.verde {
    background: ${verde};
    box-shadow: 0 10px 20px rgba(19, 115, 51, 0.2);
  }
`;

const TextoTimeline = styled.div`
  h3 {
    margin: 0.3rem 0;
    font-size: 1.5rem;
    font-weight: 800;
    transition: color 0.3s ease;
  }

  p {
    color: ${grisTexto};
    line-height: 1.6;
  }

  ${TimelineItem}:hover h3 {
    color: ${guinda};
  }
`;
const Anio = styled.div`
  color: ${guinda};
  font-size: 2rem;
  font-weight: 900;
  &.verde {
    color: ${verde};
  }
`;

const GridTarjetas = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2.5rem;
`;

const TarjetaBlanca = styled.div`
  background: white;
  border-radius: 2rem;
  padding: 4rem 2.5rem;
  text-align: center;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.03);
  border: 1px solid #f0f0f0;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-10px);
    border-color: ${guindaLight};
    box-shadow: 0 20px 50px rgba(97, 18, 50, 0.05);
  }

  h3 {
    font-size: clamp(1.8rem, 4vw, 2.8rem);
    font-weight: 900;
    margin: 1.5rem 0 0.8rem;
    color: #1a1a1a;
    letter-spacing: -1.5px;
    line-height: 1.1;
  }

  p {
    color: ${grisTexto};
    line-height: 1.6;
    font-size: 1rem;
    margin-top: 1rem;
  }
`;

const IconoCircular = styled.div`
  width: 80px;
  height: 80px;
  background: ${grisFondo};
  color: ${guinda};
  border-radius: 100px;
  margin: 0 auto;
  display: grid;
  place-items: center;
  font-size: 2rem;
  transition: all 0.3s ease;

  ${TarjetaBlanca}:hover & {
    background: ${guinda};
    color: white;
    transform: rotateY(180deg);
  }
`;
const Emoji = styled.div`
  font-size: 2.5rem;
`;

const ListaProceso = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
`;

const TarjetaProceso = styled.div`
  background: white;
  border-radius: 2rem;
  padding: 4rem 2.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  border: 1px solid #f0f0f0;
  transition: all 0.3s ease;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.03);
  perspective: 1000px;

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 20px 50px rgba(97, 18, 50, 0.05);
    border-color: ${guindaLight};
  }

  h3 {
    font-size: clamp(1.8rem, 4vw, 2.5rem);
    font-weight: 900;
    margin: 1.5rem 0 0.8rem;
    color: #1a1a1a;
    letter-spacing: -1.5px;
    line-height: 1.1;
  }

  p {
    color: ${grisTexto};
    line-height: 1.6;
    font-size: 1rem;
    margin-top: 1rem;
  }
`;

const EncabezadoProceso = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1rem;
`;

const Numero = styled.div`
  width: auto;
  padding: 0.4rem 1.2rem;
  background: ${guinda};
  color: white;
  border-radius: 100px;
  display: grid;
  place-items: center;
  font-weight: 900;
  font-size: 0.7rem;
  letter-spacing: 1px;
  box-shadow: 0 5px 15px rgba(97, 18, 50, 0.2);

  &.verde {
    background: ${verde};
    box-shadow: 0 5px 15px rgba(19, 115, 51, 0.2);
  }
`;

const IconoProceso = styled.div`
  width: 80px;
  height: 80px;
  background: ${grisFondo};
  color: ${guinda};
  border-radius: 100px;
  margin: 0 auto 1.5rem;
  display: grid;
  place-items: center;
  font-size: 2.2rem;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  transform-style: preserve-3d;

  ${TarjetaProceso}:hover & {
    transform: rotateY(180deg);
    background: ${guinda};
    color: white;
    box-shadow: 0 10px 20px rgba(97, 18, 50, 0.2);
  }

  &.verde {
    color: ${verde};
  }

  ${TarjetaProceso}:hover &.verde {
    background: ${verde};
    box-shadow: 0 10px 20px rgba(19, 115, 51, 0.2);
  }
`;

const SeccionGuinda = styled.section`
  background: linear-gradient(180deg, #4a0d26 0%, ${guinda} 100%);
  color: white;
  padding: 8rem 1.5rem;
  text-align: center;
`;

const IconoTituloClaro = styled.div`
  width: 70px;
  height: 70px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 1.5rem;
  margin: 0 auto 2rem;
  display: grid;
  place-items: center;
  font-size: 2rem;
`;

const TituloClaro = styled.h2`
  font-size: clamp(1.8rem, 4vw, 2.8rem);
  font-weight: 900;
  margin: 0;
`;

const GridStats = styled.div`
  max-width: 1100px;
  margin: 0 auto 5rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 2rem;
`;

const TarjetaStat = styled.div`
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  padding: 3.5rem 2rem;
  border-radius: 2rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
  perspective: 1000px;

  &:hover {
    transform: translateY(-10px);
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(255, 255, 255, 0.2);
  }

  h3 {
    font-size: 1.5rem;
    margin-top: 1.5rem;
    font-weight: 800;
    letter-spacing: -0.5px;
    color: white;
  }

  p {
    font-size: 0.95rem;
    opacity: 0.7;
    line-height: 1.6;
    margin-top: 0.5rem;
    color: white;
  }
`;

const NumeroStat = styled.div`
  font-size: clamp(2.2rem, 5vw, 3.2rem);
  font-weight: 900;
  color: #fff;
  margin-bottom: 0.5rem;
  letter-spacing: -1px;
`;

const IconoStat = styled.div`
  font-size: 2.8rem;
  margin-bottom: 1.5rem;
  color: white;
  opacity: 0.9;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  transform-style: preserve-3d;

  ${TarjetaStat}:hover & {
    transform: rotateY(180deg);
    opacity: 1;
  }
`;

const BotonBlanco = styled.button`
  background: white;
  color: ${guinda};
  border: none;
  border-radius: 100px;
  padding: 1rem 2.8rem;
  font-weight: 800;
`;
const Sellos = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;
  opacity: 0.5;
  margin-top: 3rem;
`;

const ListaEquipo = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 1.5rem;
`;
const TarjetaEquipo = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 1.5rem;
  display: flex;
  gap: 1.5rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.02);
`;
const IconoEquipo = styled.div`
  width: 48px;
  height: 48px;
  background: ${grisFondo};
  color: ${guinda};
  border-radius: 12px;
  display: grid;
  place-items: center;
`;

const CTA = styled.section`
  background: white;
  padding: 8rem 1.5rem;
  text-align: center;
  border-top: 1px solid #f0f0f0;
`;

const TituloCTA = styled.h2`
  font-size: clamp(2rem, 5vw, 3.2rem);
  font-weight: 900;
  margin-bottom: 2.5rem;
  letter-spacing: -1.5px;
  color: #1a1a1a;
`;

const GrupoBotones = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 3rem;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
`;

const BotonWhatsApp = styled.a`
  background: #25d366;
  color: white;
  text-decoration: none;
  border-radius: 100px;
  padding: 0.8rem 1.5rem;
  font-weight: 800;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-size: 0.95rem;
  box-shadow: 0 10px 20px rgba(37, 211, 102, 0.2);
  transition: all 0.3s ease;
  white-space: nowrap;
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 30px rgba(37, 211, 102, 0.3);
  }
`;

const BotonSecundario = styled.button`
  background: ${guinda};
  color: white;
  border: none;
  border-radius: 100px;
  padding: 0.8rem 1.5rem;
  font-weight: 800;
  font-size: 0.95rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  transition: all 0.3s ease;
  white-space: nowrap;
  box-shadow: 0 10px 20px rgba(97, 18, 50, 0.2);
  &:hover {
    background: ${guinda2};
    transform: translateY(-5px);
    box-shadow: 0 15px 30px rgba(97, 18, 50, 0.3);
  }
`;

const Beneficios = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-top: 4rem;
  span {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: 700;
    background: ${grisFondo};
    padding: 0.6rem 1.2rem;
    border-radius: 100px;
    font-size: 0.9rem;
    color: ${grisTexto};
    border: 1px solid #eee;
  }
  svg {
    color: ${verde};
  }
`;

// 4. COMPONENTE PRINCIPAL
export default function InicioAntifraude({ onConsultar, onComenzar, onConsultarExpediente }) {
  return (
    <Pagina>
      <Hero id="inicio">
        <HeroContenido>
          <MensajeHero>
            <Gris>BUSCAMOS PREVENIR Y</Gris>
            <Blanco>COMBATIR EL FRAUDE</Blanco>
          </MensajeHero>
          <TextoHero>
            Asesoría gratuita y acompañamiento legal a víctimas de fraude.
          </TextoHero>
          <ImagenAsesor src="https://images.unsplash.com/photo-1551836022-d5d88e9218df?q=80&w=1200&auto=format&fit=crop" />
        </HeroContenido>
      </Hero>

      <SeccionBlanca id="nosotros">
        <IconoTitulo>
          <FaUndo />
        </IconoTitulo>
        <TituloSeccion>Nuestra Historia</TituloSeccion>
        <Timeline>
          {historia.map((item, index) => (
            <TimelineItem key={index}>
              <CirculoLinea className={item.verde ? "verde" : ""}>
                {item.icono}
              </CirculoLinea>
              <TextoTimeline>
                <Anio className={item.verde ? "verde" : ""}>{item.anio}</Anio>
                <h3>{item.titulo}</h3>
                <p>{item.texto}</p>
              </TextoTimeline>
            </TimelineItem>
          ))}
        </Timeline>
      </SeccionBlanca>

      <SeccionGris>
        <TituloSeccion>Misión y Visión</TituloSeccion>
        <GridTarjetas>
          {misionVision.map((item, index) => (
            <TarjetaBlanca key={index}>
              <IconoCircular>{item.icono}</IconoCircular>
              <h3>{item.titulo}</h3>
              <p>{item.texto}</p>
            </TarjetaBlanca>
          ))}
        </GridTarjetas>
      </SeccionGris>

      <SeccionBlanca id="proceso">
        <IconoTitulo>
          <FaClipboardList />
        </IconoTitulo>

        <TituloSeccion>Cómo trabajamos</TituloSeccion>
        <Subtitulo>
          Un proceso claro y transparente diseñado para tu seguridad
        </Subtitulo>

        <ListaProceso>
          {proceso.map((item, index) => (
            <TarjetaProceso key={index}>
              <IconoProceso className={item.verde ? "verde" : ""}>
                {item.icono}
              </IconoProceso>
              <Numero className={item.verde ? "verde" : ""}>
                PASO {index + 1}
              </Numero>
              <h3>{item.titulo}</h3>
              <p>{item.texto}</p>
            </TarjetaProceso>
          ))}
        </ListaProceso>
      </SeccionBlanca>

      <SeccionGuinda>
        <IconoTituloClaro>
          <FaChartLine />
        </IconoTituloClaro>
        <TituloClaro>Impacto Nacional de la Campaña</TituloClaro>
        <Subtitulo
          style={{ color: "rgba(255,255,255,0.7)", marginBottom: "4rem" }}
        >
          Resultados verificables de nuestra labor en la protección del
          patrimonio ciudadano
        </Subtitulo>

        <GridStats>
          {stats.map((item, index) => (
            <TarjetaStat key={index}>
              <IconoStat>{item.icono}</IconoStat>
              <NumeroStat>{item.numero}</NumeroStat>
              <h3>{item.titulo}</h3>
              <p>{item.texto}</p>
            </TarjetaStat>
          ))}
        </GridStats>
        <BotonBlanco onClick={onComenzar}>Inicia tu proceso ahora</BotonBlanco>
      </SeccionGuinda>

      <CTA>
        <TituloCTA>¿Fuiste víctima de un fraude?</TituloCTA>
        <GrupoBotones>
          <BotonWhatsApp href="https://wa.me/5256674253" target="_blank">
            <FaPhoneAlt /> Contactar vía WhatsApp
          </BotonWhatsApp>
          <BotonSecundario onClick={onConsultar}>
            <FaFileAlt /> Consultar Folio Existente
          </BotonSecundario>
          <BotonSecundario onClick={onComenzar}>
            <FaFileAlt /> Comenzar mi proceso
          </BotonSecundario>
          <BotonSecundario onClick={onConsultarExpediente}>
            <FaFileAlt /> Consultar expediente
          </BotonSecundario>
        </GrupoBotones>

        <Beneficios>
          <span>
            <FaShieldAlt /> Proceso Seguro
          </span>
          <span>
            <FaLock /> 100% Gratuito
          </span>
        </Beneficios>
      </CTA>
    </Pagina>
  );
}
